export const PRODUCT_TYPES = {
  SUBSCRIPTION: 'subscription',
  ONE_TIME: 'charge',
  PWYW: 'pwyw',
  LEAD_CAPTURE: 'lead_capture',
  PAYMENT_PLAN: 'payment_plan',
};

export default function getProductType(product) {
  const { type, payWhatYouWant, planIterations } = product;

  if (type === 'subscription' && planIterations > 0) {
    return PRODUCT_TYPES.PAYMENT_PLAN;
  }

  if (type === 'subscription') {
    return PRODUCT_TYPES.SUBSCRIPTION;
  }

  if (type === 'charge' && payWhatYouWant === true) {
    return PRODUCT_TYPES.PWYW;
  }

  return PRODUCT_TYPES.ONE_TIME;
}

export function getProductValuesFromType(type) {
  switch (type) {
    case PRODUCT_TYPES.SUBSCRIPTION:
      return {
        type: 'subscription',
        payWhatYouWant: false,
        free: false,
        planIterations: null,
      };
    case PRODUCT_TYPES.PAYMENT_PLAN:
      return {
        type: 'subscription',
        payWhatYouWant: false,
        free: false,
      };
    case PRODUCT_TYPES.PWYW:
      return {
        type: 'charge',
        payWhatYouWant: true,
        free: false,
        discountedFromPrice: '',
        planIterations: null,
      };
    case PRODUCT_TYPES.LEAD_CAPTURE:
      return {
        type: 'charge',
        price: 0,
        payWhatYouWant: false,
        discountedFromPrice: '',
        planIterations: null,
        setupFee: '',
      };
    default:
      return {
        type: 'charge',
        payWhatYouWant: false,
        planIterations: null,
      };
  }
}

export function getPaymentTypeLabel(productType) {
  switch (productType) {
    case PRODUCT_TYPES.PAYMENT_PLAN:
      return 'payment plan';
    case PRODUCT_TYPES.SUBSCRIPTION:
      return 'subscription';
    case PRODUCT_TYPES.LEAD_CAPTURE:
      return 'submission';
    case PRODUCT_TYPES.PWYW:
      return 'payment';
    case PRODUCT_TYPES.ONE_TIME:
      return 'payment';
    default:
      return '';
  }
}

export function getPaymentsAnalyticsLabel(page) {
  if (page.type === 'checkout') {
    switch (getProductType(page.product)) {
      case PRODUCT_TYPES.PAYMENT_PLAN:
      case PRODUCT_TYPES.SUBSCRIPTION:
        return 'Subscriptions & analytics';
      case PRODUCT_TYPES.LEAD_CAPTURE:
        return 'Submissions & analytics';
      case PRODUCT_TYPES.PWYW:
      case PRODUCT_TYPES.ONE_TIME:
      default:
        return 'Payments & analytics';
    }
  }

  if (page.type === 'form') {
    return 'Submissions & analytics';
  }

  if (page.type === 'event') {
    return 'Payments & analytics';
  }
}

export function getPaymentsLabel(page) {
  if (page.type === 'checkout') {
    switch (getProductType(page.product)) {
      case PRODUCT_TYPES.PAYMENT_PLAN:
      case PRODUCT_TYPES.SUBSCRIPTION:
        return 'Subscriptions';
      case PRODUCT_TYPES.LEAD_CAPTURE:
        return 'Submissions';
      case PRODUCT_TYPES.PWYW:
      case PRODUCT_TYPES.ONE_TIME:
      default:
        return 'Payments';
    }
  }

  if (page.type === 'form') {
    return 'Submissions';
  }

  if (page.type === 'event') {
    return 'Payments';
  }
}

export function getPaymentsSlug(page) {
  if (page.type === 'checkout') {
    switch (getProductType(page.product)) {
      case PRODUCT_TYPES.PAYMENT_PLAN:
      case PRODUCT_TYPES.SUBSCRIPTION:
        return 'subscriptions';
      case PRODUCT_TYPES.LEAD_CAPTURE:
      case PRODUCT_TYPES.PWYW:
      case PRODUCT_TYPES.ONE_TIME:
      default:
        return 'payments';
    }
  }

  if (page.type === 'form') {
    return 'submissions';
  }

  if (page.type === 'event') {
    return 'payments';
  }
}

export function getOrderType(page) {
  if (page.type === 'checkout') {
    switch (getProductType(page.product)) {
      case PRODUCT_TYPES.PAYMENT_PLAN:
        return 'payment plan';
      case PRODUCT_TYPES.SUBSCRIPTION:
        return 'subscription';
      case PRODUCT_TYPES.LEAD_CAPTURE:
        return 'submission';
      case PRODUCT_TYPES.PWYW:
        return 'payment';
      case PRODUCT_TYPES.ONE_TIME:
        return 'payment';
      default:
        return '';
    }
  }

  if (page.type === 'form') {
    return 'submission';
  }

  if (page.type === 'event') {
    return 'booking';
  }
}
